'use client';

import Script from 'next/script';

const hubSpotAccountId = process.env.NEXT_PUBLIC_HUBSPOT_ACCOUNT_ID;

// Tracked manually per route change (see PageViewTracker), not at init, to count SPA navigations
export const trackHubSpotPageView = (pathname: string) => {
  if (!process.env.NEXT_PUBLIC_HUBSPOT_ACCOUNT_ID || typeof window === 'undefined' || window.E2E_TEST) {
    return;
  }

  // eslint-disable-next-line no-underscore-dangle
  window._hsq = window._hsq || [];
  // eslint-disable-next-line no-underscore-dangle
  window._hsq.push(['setPath', pathname]);
  // eslint-disable-next-line no-underscore-dangle
  window._hsq.push(['trackPageView']);

  // CTA script reads location.href once at load; SPA navigations need this to re-evaluate display rules
  window.HubSpotCallsToActions?.refresh();
};

export const HubSpotPixel = () => {
  if (!hubSpotAccountId || (typeof window !== 'undefined' && window.E2E_TEST)) {
    return null;
  }

  return (
    <>
      {/* Initialize the HubSpot tracking queue. Then disable HubSpot chat auto-load, keep tracking. */}
      <Script
        dangerouslySetInnerHTML={{
          __html: `window._hsq = window._hsq || []; window.hsConversationsSettings = { loadImmediately: false };`,
        }}
        id="hs-script-loader-config"
        strategy="afterInteractive"
      />
      <Script
        id="hs-script-loader"
        src={`https://js.hs-scripts.com/${hubSpotAccountId}.js?businessUnitId=1237045`}
        strategy="afterInteractive"
      />
    </>
  );
};
